
import { Options, prop, Vue } from "vue-class-component";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import HistoryChat from "./components/history-chat.vue";
import ChatBoxMessage from "./components/chat-box-message.vue";
import { TicketDetail, TicketAction } from '@/domain/entities/PusatResolusiV2';
import FollowReport from "../components/follow-report.vue";
import { PusatResolusiV2Mapper } from '@/data/persistences/mappers/PusatResolusiV2Mapper';

class Props {
  data = prop<TicketDetail>({
    required: true
  });
  detailId = prop<number>({
    required: true
  });
  websocket = prop<WebSocket>({
    required: true
  });
  action = prop<TicketAction>({
    required: true
  });
}

@Options({
  components: {
    HistoryChat,
    ChatBoxMessage,
    FollowReport
  },
  watch: {
    action: {
      handler(val: TicketAction) {
        this.ticketAction = val;
      },
    },
    websocket: {
      handler(ws: WebSocket) {
        ws.addEventListener("message", async event => {
          const mapper = new PusatResolusiV2Mapper();
          const conversation = mapper.convertHistoryChatResponseFromWebsocket(event.data)[0];

          if (!conversation.type) {
            this.ticketAction = new TicketAction({
              isOpenMultipleTab: conversation.isOpenMultipleTab,
              isAssignedToOther: conversation.isAssignedToOther,
              assignedUsername: conversation.assignedUsername,
              action: conversation.action
            })
            this.isLoadingAction = false;
          };
        })
      }
    }
  }
})
export default class HistorySection extends Vue.with(Props) {
  ticketAction = new TicketAction()
  isLoadingAction = true;

  get isShowChat() {
    return this.ticketAction.action.includes("chat");
  }
  get isShowFollow() {
    return this.ticketAction.action.includes("follow");
  }

  get message(): string {
    return PusatResolusiV2Controller.chatMessage;
  }

  set message(val: string) {
    PusatResolusiV2Controller.setChatMessage(val);
  }

  get caseNumber() {
    return this.data.ticket.caseNumber.toString();
  }

  async getTicketAction() {
    try {
      this.isLoadingAction = true;
      this.ticketAction = await PusatResolusiV2Controller.getTicketAction(Number(this.$route.params.id as string));
      this.$emit("updateAction", this.ticketAction);
    } catch (err) {
      // implement error
    } finally {
      this.isLoadingAction = false;
    }
  }
}
